/**
 * Painel visual da entrada: um tabuleiro em posição de abertura.
 *
 * Desenhado em CSS, não carregado de fora. O CSP do site é `img-src 'self'
 * data:`, então imagem hospedada em outro domínio seria bloqueada pelo
 * navegador e a metade esquerda da tela ficaria vazia — sem erro visível,
 * só um buraco.
 *
 * Decorativo, então fica fora da árvore de acessibilidade.
 */
export function PainelTabuleiro() {
  return (
    <div
      className="relative h-full w-full overflow-hidden grid place-items-center p-10"
      style={{
        background: `
          radial-gradient(120% 90% at 20% 0%, color-mix(in oklab, var(--primary) 22%, transparent), transparent 60%),
          linear-gradient(160deg, var(--board-frame), color-mix(in oklab, var(--board-frame) 60%, black))
        `,
      }}
    >
      {/* Trama do feltro, bem fraca. */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(45deg, rgb(255 255 255 / 0.04) 0 1px, transparent 1px 5px),
            repeating-linear-gradient(-45deg, rgb(0 0 0 / 0.05) 0 1px, transparent 1px 5px)
          `,
        }}
      />

      <div className="relative w-full max-w-sm">
        <div className="moldura rotate-[-5deg]">
          <div className="aspect-square grid grid-cols-8 grid-rows-8 rounded-sm overflow-hidden">
            {Array.from({ length: 64 }, (_unused, i) => {
              const linha = Math.floor(i / 8);
              const coluna = i % 8;
              const escura = (linha + coluna) % 2 === 1;
              const pecaClara = escura && linha >= 5;
              const pecaEscura = escura && linha <= 2;

              return (
                <div
                  key={i}
                  className="grid place-items-center"
                  style={{ background: escura ? 'var(--board-dark)' : 'var(--board-light)' }}
                >
                  {pecaClara || pecaEscura ? (
                    <span
                      className="block w-[72%] aspect-square rounded-full"
                      style={{
                        background: pecaClara
                          ? 'radial-gradient(circle at 34% 28%, color-mix(in oklab, var(--piece-light) 100%, white 12%), var(--piece-light) 55%, color-mix(in oklab, var(--piece-light) 82%, black 18%))'
                          : 'radial-gradient(circle at 34% 28%, color-mix(in oklab, var(--piece-dark) 78%, white 22%), var(--piece-dark) 58%, color-mix(in oklab, var(--piece-dark) 88%, black 12%))',
                        boxShadow:
                          '0 2px 3px oklch(0 0 0 / 0.35), inset 0 -2px 3px oklch(0 0 0 / 0.22), inset 0 2px 2px oklch(1 0 0 / 0.25)',
                      }}
                    />
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-10 text-center">
          <p
            className="font-bold leading-tight"
            style={{ fontSize: 'var(--text-title)', color: 'var(--board-light)' }}
          >
            A habilidade decide.
          </p>
          <p
            className="mt-1 font-bold leading-tight"
            style={{ fontSize: 'var(--text-title)', color: 'var(--board-highlight)' }}
          >
            A sorte não entra.
          </p>
        </div>
      </div>
    </div>
  );
}
